(function () {
  const cache = {};

  function buildCard(product) {
    const img = product.images[0]
      ? `<img src="${product.images[0].src}" alt="${product.title}" loading="lazy">`
      : '';
    return `
      <div class="card" onclick="window.location='/products/${product.handle}'" style="cursor:pointer;">
        <div class="product-img">${img}</div>
        <div class="product-content">
          <h3 class="product-title">${product.title}</h3>
          <span>${product.variants[0]?.weight ? product.variants[0].weight + ' ' + product.variants[0].weight_unit : ''}</span>
          <a href="/products/${product.handle}">Learn More</a>
        </div>
      </div>`;
  }

  function fetchProducts(handle, container, limit = 4) {
    if (!handle || handle === '' || handle.includes('/')) return;
    if (container && container.dataset.loaded === 'true') return;

    if (cache[handle]) {
      if (container) renderProducts(cache[handle], container);
      return;
    }

    if (!container) {
      fetch(`/collections/${handle}/products.json?limit=${limit}`)
        .then(res => res.json())
        .then(data => { cache[handle] = data.products; })
        .catch(() => {});
      return;
    }

    container.innerHTML = '<div style="padding:10px;font-size:13px;">Loading...</div>';

    fetch(`/collections/${handle}/products.json?limit=${limit}`)
      .then(res => res.json())
      .then(data => {
        cache[handle] = data.products;
        renderProducts(data.products, container);
      })
      .catch(() => {
        container.innerHTML = '<div style="padding:10px;font-size:13px;">Unable to load.</div>';
      });
  }

  function renderProducts(products, container) {
    if (!products || products.length === 0) {
      container.innerHTML = '<div style="padding:10px;font-size:13px;">No products found.</div>';
      return;
    }
    container.innerHTML = products.map(buildCard).join('');
    container.dataset.loaded = 'true';
  }

  function loadTabContent(megaMenu, tabContent) {
    const mode = tabContent.dataset.mode;

    if (mode === 'direct') {
      const productContainer = tabContent.querySelector('.products');
      if (productContainer) {
        fetchProducts(productContainer.dataset.collection, productContainer, 5); // 👈 change limit here
      }
    } else {
      tabContent.querySelectorAll('.sub-tab').forEach(t => t.classList.remove('active'));
      tabContent.querySelectorAll('.products').forEach(p => p.classList.remove('active'));

      const firstSub = tabContent.querySelector('.sub-tab');
      if (firstSub) {
        firstSub.classList.add('active');
        const productContainer = megaMenu.querySelector('#' + firstSub.dataset.sub);
        if (productContainer) {
          productContainer.classList.add('active');
          fetchProducts(firstSub.dataset.collection, productContainer); // default 4
        }
      }
    }
  }

  function initMegaMenu(megaMenu) {

    /* MAIN TABS */
    megaMenu.querySelectorAll('.main-tab').forEach(tab => {
      tab.addEventListener('mouseenter', () => {
        megaMenu.querySelectorAll('.main-tab').forEach(t => t.classList.remove('active'));
        megaMenu.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));

        tab.classList.add('active');

        const currentTab = megaMenu.querySelector('#' + tab.dataset.tab);
        if (!currentTab) return;
        currentTab.classList.add('active');

        loadTabContent(megaMenu, currentTab);
      });
    });

    /* SUB TABS */
    megaMenu.querySelectorAll('.sub-tab').forEach(tab => {
      tab.addEventListener('mouseenter', () => {
        const parent = tab.closest('.tab-content');
        if (!parent) return;

        parent.querySelectorAll('.sub-tab').forEach(t => t.classList.remove('active'));
        parent.querySelectorAll('.products').forEach(p => p.classList.remove('active'));

        tab.classList.add('active');

        const productContainer = megaMenu.querySelector('#' + tab.dataset.sub);
        if (productContainer) {
          productContainer.classList.add('active');
          fetchProducts(tab.dataset.collection, productContainer);
        }
      });
    });

    /* LOAD FIRST ACTIVE TAB ON INIT */
    const firstActiveTab = megaMenu.querySelector('.tab-content.active');
    if (firstActiveTab) {
      loadTabContent(megaMenu, firstActiveTab);
    }
  }

  /* BOOT ON PARENT HOVER — init once per menu */
  document.querySelectorAll('.header-menu-item').forEach(item => {
    let initialized = false;
    item.addEventListener('mouseenter', () => {
      const menu = item.querySelector('.mega-menu');
      if (menu && !initialized) {
        initialized = true;
        initMegaMenu(menu);
      }
    });
  });

  /* PRE-FETCH ON PAGE LOAD */
  document.querySelectorAll('.header-menu-item').forEach(item => {
    const menu = item.querySelector('.mega-menu');
    if (!menu) return;

    // Pre-fetch normal sub-tabs
    menu.querySelectorAll('.sub-tab').forEach(tab => {
      const handle = tab.dataset.collection;
      if (handle) fetchProducts(handle, null);
    });

    // Pre-fetch direct mode collections
    menu.querySelectorAll('.tab-content[data-mode="direct"] .products').forEach(p => {
      const handle = p.dataset.collection;
      if (handle) fetchProducts(handle, null, 5); // 👈 match the same limit
    });
  });

})();